import { uid } from "uid"

const initialState = {
    homes: [
    {
        name: 'Villa Duplex Haut Standing 6 Pièces',
        project:'Riviera Golf 4',
        address: 'Belle villa meublée haut standing située à Songon  Riviera Golf 4  à proximité du lycée Blaise Pascal,',
        description:[
            'Superbe penthouse de 3 pièces à Riviera mondial béton avec vue sur la lagune ',
            'chambre principale autonome','salle d’eau extérieure à la seconde chambre',
            'toilette visiteur','séjour staffé','cuisine européenne','immense terrasse et immense cour'
        ],
        prices :'5500000',
        img :[
            "villa 21.jpeg",
            "villa 21.jpeg",
            "villa 22.jpeg",
            "villa 03.jpg",
        ],
        id:2,
    },
    {
        name: 'Belle Villa 8 pièces ',
        project:'Angré 8eme Tranche',
        addresse: 'Belle Villa 8 pièces Angré 8eme Tranche',
        description:[
            '1 chambre principale','7 chambres autonomes','salle d’eau extérieure à la seconde chambre',
            'toilette visiteur','séjour staffé','cuisine européenne','immense terrasse et immense cour'
        ],
        prices :'1 500 000',
        img :[
            "villa 026.jpg",
            "villa 021.jpg",
            "villa 022.jpg",
            "villa 023.jpg",
        ],
        id:1,
    },
    {
        id : 100,
        project:'Angré Cité Arcades',
        name:"Villa Duplex Haut Standing 6 Pièces",
        city : "Abidjan , Cote d'Ivoire",
        address : "Cocody Angré Arcades III",
        // img:'M10.JPG',
        img : ["M1.jpg","M2.jpg","M3.jpg","M4.jpg"],
        prices :'750 000',
        description : ["Villa Duplex 4 pièces ", " 3 chambres indépendantes complètes" ," 1 chambre parental", " Terrasse" , "Cours avant et arrière"]
    },

    // {
    //     name: 'Villa Duplex 5 Pièces Yopougon ',
    //     project:'Riviera Golf 4',
    //     addresse: 'Belle villa meublée haut standing située à Songon  Riviera Golf 4  à proximité du lycée Blaise Pascal,',
    //     description:[
    //         'Superbe penthouse de 3 pièces à Riviera mondial béton avec vue sur la lagune ',
    //         'chambre principale autonome','salle d’eau extérieure à la seconde chambre',
    //         'toilette visiteur','séjour staffé','cuisine européenne','immense terrasse et immense cour'
    //     ],
    //     prices :'5500000',
    //     img :[
    //         "villa 50.jpg",
    //         "villa 51.jpg",
    //         "villa 52.jpg",
    //         "villa 53.jpg",
    //     ],
    //     id:3,
    // },
    ],

    rentHomes: [
        {
            name: 'Belle Villa 8 pièces ',
            project:'Angré 8eme Tranche',
            address: 'Belle Villa 8 pièces Angré 8eme Tranche',
            nmbres:"8 pièces",
            types:"Appartement",
            description:[
                '1 chambre principale','7 chambres autonomes','salle d’eau extérieure à la seconde chambre',
                'toilette visiteur','séjour staffé','cuisine européenne','immense terrasse et immense cour'
            ],
            prices :'1 500 000',
            img :[
                "villa 026.jpg",
                "villa 021.jpg",
                "villa 022.jpg",
                "villa 023.jpg",
            ],
            id:4,
        },

    {
        name: 'Belle Villa Meublée de 6 Pièces',
        project:'Riviera Golf 4',
        address: 'Belle villa meublée haut standing située à Songon  Riviera Golf 4',
        description:[
            'Superbe penthouse de 3 pièces à Riviera mondial béton avec vue sur la lagune ',
            'chambre principale autonome','salle d’eau extérieure à la seconde chambre',
            'toilette visiteur','séjour staffé','cuisine européenne','immense terrasse et immense cour'
        ],
        prices :'5500000',
        nmbres:"2 pièces",
        types:"Appartement",
        img :[
            "villa 21.jpeg",
            "villa 21.jpeg",
            "villa 22.jpeg",
            "villa 03.jpg",
        ],
        id:5,
    },
    {
        id : 100,
        project:'Angré Cité Arcades',
        name:"Villa Duplex Haut Standing 6 Pièces",
        city : "Abidjan , Cote d'Ivoire",
        address : "Cocody Angré Arcades III",
        // img:'M10.JPG',
        img : ["M1.jpg","M2.jpg","M3.jpg","M4.jpg"],
        prices :'750 000',
        description : ["Villa Duplex 4 pièces ", " 3 chambres indépendantes complètes" ," 1 chambre parental", " Terrasse" , "Cours avant et arrière"],
        nmbres:"7 pièces",
        types:"Villas",
    },

    // {
    //     name: 'Belle Villa Meublée de 6 Pièces ',
    //     project:'Riviera Golf 4',
    //     addresse: 'Belle villa meublée haut standing située à Songon  Riviera Golf 4  à proximité du lycée Blaise Pascal,',
    //     description:[
    //         'Superbe penthouse de 3 pièces à Riviera mondial béton avec vue sur la lagune ',
    //         'chambre principale autonome','salle d’eau extérieure à la seconde chambre',
    //         'toilette visiteur','séjour staffé','cuisine européenne','immense terrasse et immense cour'
    //     ],
    //     prices :'5500000',
    //     nmbres:"8 pièces",
    //     types:"Villa",
    //     img :[
    //         "villa 01.jpg",
    //         "villa 02.jpg",
    //         "villa 05.jpeg",
    //         "villa 07.jpeg",
    //     ],
    //     id:7,
    // },

   
    ],

    realisations : [
        {
            id : 100,
            name:"Cité Arcades",
            city : "Abidjan , Cote d'Ivoire",
            address : "Cocody Angré Arcades III",
            img:'M1.jpg',
            images : ["M1.jpg","M2.jpg","M3.jpg","M4.jpg","M5.jpg","M6.jpg","M7.jpg"],
            prices :'1500000',
            description : ["Villa Duplex 4 pièces ", " 3 chambres indépendantes complètes" ," 1 chambre parental", " Terrasse" , "Cours avant et arrière"]
        },
        {
            id : 101,
            name:"Cité Arcades",
            city : "Abidjan , Cote d'Ivoire",
            address : "Cocody Angré 8ème Tranche",
            img:'mc.jpg',
            images : ["mc.JPG","mb.JPG","IMG_5771.jpg","IMG_5770.jpg","IMG_5769.jpg","IMG_5768.jpg","IMG_5768.jpg"],
            description : ["Villa Duplex 8 pièces ", " 7 chambres indépendantes complètes" ," 1 chambre parental" , " Terrasse" , "Cours avant et arrière"]
        },
        {
            id : 102,
            name:"Immeuble DS'88",
            city : "Abidjan , Cote d'Ivoire",
            address : "Cocody Angré Cocovico",
            img:'40.jpg',
            images : ["40.jpg","41.jpg","42.jpg","43.jpg","44.jpg"],
            description : ["Villa Duplex 4 pièces ", " 3 chambres indépendantes complètes" ," 1 chambre parental"]
        },

    ]

}

export function homeReducer(state = initialState, action) {
    switch (action.type) {
        case "GET-HOMES": {
            return {
                ...state,homes : action.payload
            }
        }
        case "GET-RENT-HOMES": {
            return {
                ...state,rentHomes : action.payload
            }
        }
        default: {
            return state
        }
    }
  
}